import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { moduleActions } from '../../redux/modules';
import { AuthServiceProvider, AuthGate } from '@trp-ta-nitro/auth-react';

import AuthenticationSpinner from './AuthenticationSpinner';
import Root from '../Root/Root';
import {setApiKey} from "../../utils/api/axios";

function inAllowedIFrame() {
  try {
    const isSandbox = window.location.host.includes('localhost');
    const isInternalDomain =
        window.location.host.includes('awstrp') || isSandbox;
    const iFrameNameIsValid = window.name === 'ii-salesforce';
    const inIFrame = window.self !== window.top && iFrameNameIsValid;
    return inIFrame && isInternalDomain;
  } catch (e) {
    return false;
  }
}

function isRepFromSalesforce() {
  return (
      window.location.pathname.includes('salesforce') &&
      window.location.host.includes('awstrp')
  );
}

const AuthenticationContainer = () => {
  const dispatch = useDispatch();
  const isIFrame = inAllowedIFrame();
  const isSalesforceRep = isRepFromSalesforce();

  /* eslint-disable */
  useEffect(() => {
    dispatch(moduleActions.setSalesforceRep({
      isIFrame: isIFrame,
      isSalesforceRep: isSalesforceRep,
    }))
  }, []);

  useEffect(() => {
    dispatch(moduleActions.getAPIKey())
  }, []);
  /* eslint-enable */

  const apiKey = useSelector(state => state.applicationConfig.apikey);
  setApiKey(apiKey);
  const configLoaded = useSelector(state => state.applicationConfig.isLoaded);
  const authOptions = {
    apiKey,
    types: {
      // enable external and internal both, no extra options are required so none are passed
      external: {},
      internal: {
        customerWebViewEnabled: true
      },
    },
  };

  return configLoaded && apiKey ? (
      <AuthServiceProvider options={authOptions}>
        <AuthGate internalEntitlements={[['su-admins'], ['portal_retaildesktop_base']]}>
          <Root />
        </AuthGate>
      </AuthServiceProvider>
    ) : (
      <AuthenticationSpinner />
    );
};

export default AuthenticationContainer;